<template lang="pug" src="./reason-editor.pug"></template>
<style lang="scss" src="./reason-editor.scss" scoped> </style>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import validate from '@/mixins/validate';

export default {
    mixins: [validationMixin, validate],
    props: {
        reason: {
            type: Object,
            default() {
                return {
                    types: [],
                    name: null
                };
            }
        }
    },
    validations: {
        reason: {
            name: {
                required
            },
            types: {
                $each: {
                    name: {
                        required
                    }
                }
            }
        }
    },
    computed: {
        canAddType() {
            return this.reason.types.length == 0 || this.reason.types.every(it => !!it.name) ;
        }
    },
    methods: {
        addReasonType() {
            if (this.canAddType) {
                this.reason.types.push({});
                this.$v.$reset();
            } else {
                this.$v.$touch();
            }
        },

        removeType(index) {
            this.reason.types.splice(index, 1);
        },

        resetData() {
            this.reason.types = [];
            this.reason.name = null;
            this.$v.$reset();
        }
    }
};
</script>
